import Config from '../../AppConfig';
import { get } from './core/fetch';

export const getRecentClients = async (key: string): Promise<any> => {
	try {
		return await get(`${Config.mlcApiPrefix}/advisers/${key}/recentClients`, {
			withAuth: true,
			noGateway: false,
		});
	} catch (err) {
		return [];
	}
};
